import { render, staticRenderFns } from "./research.html?vue&type=template&id=02779c46&scoped=true&"
import script from "./research.js?vue&type=script&lang=js&"
export * from "./research.js?vue&type=script&lang=js&"
import style0 from "./research.scss?vue&type=style&index=0&id=02779c46&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=02779c46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02779c46",
  null
  
)

export default component.exports